import { useMemo } from 'react'
import { useAgentRuns } from '~/entities/document-agent'
import { getApiErrorStatus } from '~/shared/lib/api-error'
import { Alert, Button, DataTableLoadingSkeleton, Text } from '~/shared/ui'
import { TABLE_COLUMNS_COUNT } from '../config'
import { useAgentRunsFilters } from '../model'
import { AgentRunsFilters } from './agent-runs-filters'
import { AgentRunsPerformance } from './agent-runs-performance'
import { AgentRunsTable } from './agent-runs-table'

export function AgentRunsPage() {
  const { filters, updateFilters } = useAgentRunsFilters()
  const {
    data,
    error,
    isPending,
    isError,
    refetch,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useAgentRuns(filters)
  const items = useMemo(() => data?.pages.flatMap((page) => page.items) ?? [], [data])

  return (
    <div className="flex h-full flex-col overflow-hidden">
      <div className="border-divider flex shrink-0 flex-col gap-3 border-b px-6 py-4">
        <Text appearance="H6">Agent runs</Text>
        <AgentRunsFilters
          filters={filters}
          onChange={updateFilters}
        />
        {!isPending && !isError && items.length > 0 && <AgentRunsPerformance items={items} />}
      </div>
      <div className="flex-1 overflow-hidden">
        {isPending ? (
          <DataTableLoadingSkeleton
            columnsCount={TABLE_COLUMNS_COUNT}
            rowsCount={10}
            withStickyHeader
          />
        ) : isError ? (
          <div className="flex flex-col items-start gap-3 p-6">
            <Alert
              className="grow-0"
              appearance="ERROR"
              materialIcon="error"
            >
              {getApiErrorStatus(error) === 403
                ? 'Agent runs are not available for your account.'
                : 'Could not load agent runs.'}
            </Alert>
            {getApiErrorStatus(error) !== 403 && (
              <Button onClick={() => refetch()}>Try again</Button>
            )}
          </div>
        ) : (
          <AgentRunsTable
            items={items}
            hasNextPage={hasNextPage}
            isFetchingNextPage={isFetchingNextPage}
            onLoadMore={() => fetchNextPage()}
          />
        )}
      </div>
    </div>
  )
}
